module.exports = __webpack_public_path__ + "img/setuptimep-min.ac11c66d.jpg";